import { useEffect, useState } from 'react'
import { Ga4Events } from '../../events/index'
import { useCart } from '../../../../core/hooks/index'

export const BeginCheckout = () => {
  const { cart } = useCart()

  const [firstLoaded, setFirstLoaded] = useState(true)

  useEffect(() => {
    if (firstLoaded) {
      setFirstLoaded(false)
      Ga4Events.beginCheckout({ cart })
    }
  }, [firstLoaded, cart])

  return null
}
